import React from "react";
import { Link } from "react-router-dom";

const OtherPortfolioDetails = ({ dataList = [], id , services}) => {
    if (!Array.isArray(dataList) || dataList.length === 0) return null;

    const currentId = String(id);

    const currentItem = dataList.find(
        (item) => String(item.id) === currentId
    );

    if (!currentItem) return null;

    const currentTags = Array.isArray(currentItem.tags)
        ? currentItem.tags
        : [];

    /*
     * Priority:
     * 1. Same service (tag intersection)
     * 2. Exclude current project
     * 3. Limit 5 items
     */
    const otherProjects = dataList
        .filter((item) => String(item.id) !== currentId)
        .filter((item) => {
            if (!currentTags.length) return true;
            return item.tags?.some((tag) => currentTags.includes(tag));
        })
        .slice(0, 5);

    if (otherProjects.length === 0) return null;

    return (
        <div className="portfolio-details__mini">
            <h5 className="mini-title">Other Projects</h5>

            <div className="mini-list">
                {otherProjects.map((item) => (
                    <Link
                        to={`/portfolio/${item.id}`}
                        key={item.id}
                        className="mini-card"
                    >
                        <div className="mini-card__image">
                            <img
                                src={item.images?.[0]}
                                alt={item.title}
                                loading="lazy"
                            />
                        </div>

                        <div className="mini-card__content">
                            <h6>{item.title}</h6>
                            <span>{item.caption}</span>
                        </div>
                    </Link>
                ))}
            </div>

            <Link to="/portfolio" className="mini-view-more">
                View All Projects <i className="flaticon-right-up" />
            </Link>
        </div>
    );
};

export default OtherPortfolioDetails;
